module.exports = __webpack_public_path__ + "static/pub-9b6e13c575c2db123ea3015f0d4b3499.jpg";